<template>
    <page>
        <module>
            <module-tab title="阿里云配置">
                <c-form ref="form6">
                    <c-form title="基础配置">
                        <c-form-item type="input" label="用户公钥" name="OSS_ACCESSKEYID" word="注:阿里云OSS用户公钥（AccessKeyId）"></c-form-item>
                        <c-form-item type="input" label="用户私钥" name="OSS_ACCESSKEYSECRET" word="注:阿里云OSS用户私钥（AccessKeySecret）"></c-form-item>
                        <c-form-item type="input" label="存储空间名" name="OSS_BUCKETNAME" word="注:阿里云OSS中自定义的Bucket名称"></c-form-item>
                        <c-form-item type="input" label="上传地址URL" name="OSS_HOST" word="注:上传至阿里云oss的地址，不同区域的地址可能不同，示例：https://yci.oss-cn-hangzhou.aliyuncs.com/"></c-form-item>
                        <c-form-item type="input" label="访问地址前缀" name="OSS_ENDPOINT" word="注:上传完成的文件的访问地址前缀，示例：https://cdn.yunchange.com/"></c-form-item>
                        <c-form-item type="input" label="角色ARN" name="OSS_ROLEARN" word="注:控制OSS增删改查权限，可在阿里云后台，RAM访问控制->角色功能中查看"></c-form-item>
                    </c-form>
                </c-form>
            </module-tab>
            <template slot="button">
                <c-button size="m" power="m_platform_config" @click="save()">保存</c-button>
            </template>
        </module>

        <c-dialog ref="wechatPayEdit" title="微信收款账户配置" width="600" @resolve="wechatPaySubmit">
            <c-form ref="wechatPayForm">
                <c-form-item type="input" label="AppID" name="appID" required word="微信分配的小程序APP ID"></c-form-item>
                <c-form-item type="input" label="商户号" name="mchID" required word="微信支付分配的商户号ID"></c-form-item>
                <c-form-item type="input" label="密钥KEY" name="key" required word="安全检验码,用于加解密数据"></c-form-item>
                <c-form-item type="file" label="证书" name="cert_file" required file-word="请选择证书文件"></c-form-item>
            </c-form>
        </c-dialog>

        <c-dialog ref="aliPayEdit" title="支付宝收款账户配置" width="600" @resolve="aliPaySubmit">
            <c-form ref="aliPayForm">
                <c-form-item type="input" label="AppID" name="app_id" required word="支付宝收款账户ID"></c-form-item>
                <c-form-item type="input" label="收款账号" name="partner" required word="合作身份者ID，签约账号，以2088开头由16位纯数字组成的字符串，查看地址：https://b.alipay.com/order/pidAndKey.htm"></c-form-item>
                <c-form-item type="input" label="密钥KEY" name="key" required word="安全检验码，由数字和字母组成的32位字符串，查看地址：https://b.alipay.com/order/pidAndKey.htm"></c-form-item>
                <c-form-item type="textarea" label="秘钥" name="private_key" required word="支付宝秘钥"></c-form-item>
                <c-form-item type="textarea" label="公钥" name="public_key" required word="支付宝公钥"></c-form-item>
            </c-form>
        </c-dialog>
    </page>
</template>

<script>

    export default {
        name: 'm_platform_config',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
                OMS_SELLER_SHOP_ENABLED: 'OFF',
				ORDER_PUSH_ENABLED: 'OFF',
                EXPRESS_QUERY_ENABLED: 'OFF',
                ADDRESS_QUERY_ENABLED: 'OFF',
                PC_ENABLED: 'ON',//是否开启PC端
                MOBILE_ENABLED: 'ON',//是否开启移动端
                OSS_IMAGESEARCH_ENABLED: 'OFF',//支持按图片搜索
				PT_MODE: 1,
                fromData:{
                    qiyukf_user_id:{id:'4',value:''},
                    oms_login_verify_switch:{id:'1',value:'ON'},
                    withdrawal_rate:{id:'2',value:''},
                    a_single_withdrawal_limit:{id:'3',value:''},
                    order_points_enabled:{id:'5',value:'ON'},
                    order_points_money_unit:{id:'6',value:''},
                    order_points_expired_period:{id:'7',value:''},
                    return_order_check_enabled:{id:'20',value:'ON'},
                },
                switchOptions: [{
                    name: '开启',
                    value: 'ON'
                }, {
                    name: '关闭',
                    value: 'OFF'
                }],
	            occupancyTypeOptions:[{
                    name: '下单后占用',
                    value: '1'
                }, {
                    name: '支付后占用',
                    value: '2'
                }],
                WECHAT_PAY:'OFF',
                ALI_PAY:'OFF',
                wechatReceiveAccount: {},        //微信支付收款账户信息
                alipayReceiveAccount: {},        //支付宝收款账户信息
                POINTS_SYSTEM:'OFF',
                SHARE_ENABLE:'OFF',
                ORDER_EVALUATE:'OFF'//是否开启评价功能
            }
        },

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach((item,i)=>{
                            var value = item.config_item_value;
                            if (item.config_item_code == 'WITHDRAWAL_RATE'){
                                value = value*100;
                            }
                            if (item.config_item_code == 'WECHAT_RECEIVE_ACCOUNT'){
                                if (value){
                                    this.wechatReceiveAccount = JSON.parse(value);
                                }
                            }else if (item.config_item_code == 'ALIPAY_RECEIVE_ACCOUNT'){
                                if (value){
                                    this.alipayReceiveAccount = JSON.parse(value);
                                }
                            }else {
                                json[item.config_item_code] = value;
                            }
                        });
                        this.$nextTick(() => {
                            if(this.$refs.form6)this.$refs.form6.set(json);
                        });
                    }
                });
            },

            save() {
                let data6 = this.$refs.form6?this.$refs.form6.get():{};
                let submitData = Object.assign({}, data6);
                let platform_config_list = [];
                for (let key in submitData) {
                    var value = submitData[key];
                    if (key == 'WITHDRAWAL_RATE'){
                        value = value/100;
                    }
                   /* if (key == 'SHARE_ENABLE'){
                        if (this.PT_MODE == 2){//所商户，则默认关闭分销功能
                            value = 'OFF';
                        }
                    }*/
                    platform_config_list.push({
                        config_item_code: key,
                        config_item_value: value || ''
                    });
                }
                this.request({
                    url: '/platform_config/edit',
                    data: {
                        platform_config_list: platform_config_list
                    },
                    loading: true,
                    success: data => {
                        this.$store.dispatch('getSystemConfig');
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                        //刷新页面
                        this.getDetail();
                    }
                });
            },

            //配置【微信】收款账户信息
            wechatPayConfig(){
                this.$refs.wechatPayForm.set(this.wechatReceiveAccount);
                this.$refs.wechatPayEdit.open();
            },
            //提交微信支付数据
            wechatPaySubmit(stop) {
                stop();
                this.$refs.wechatPayForm.submit({
                    url: '/platform_config/edit/by/code',
                    rule: {
                        appID: '请填写AppID',
                        mchID: '请填写商户号',
                        key: '请填写密钥KEY',
                        cert_file: '请上传证书文件'
                    },
                    dataFormatter: data => {
                        this.wechatReceiveAccount = {
                            appID:data.appID,
                            mchID:data.mchID,
                            key:data.key,
                            cert_file:data.cert_file
                        }
                        var submitObj = {};
                        submitObj.config_item_code = 'WECHAT_RECEIVE_ACCOUNT';
                        submitObj.config_item_value = JSON.stringify(this.wechatReceiveAccount);
                        return submitObj;
                    },
                    success:(data,res) => {
                        this.$message({
                            text: '微信收款账户信息配置成功',
                            icon: 'success'
                        });
                        this.$refs.wechatPayEdit.close();
                    },
                });
            },

            //配置【支付宝】收款账户信息
            aliPayConfig(){
                this.$refs.aliPayForm.set(this.alipayReceiveAccount);
                this.$refs.aliPayEdit.open();
            },

            //提交【支付宝】收款账户信息
            aliPaySubmit(stop) {
                stop();
                this.$refs.aliPayForm.submit({
                    url: '/platform_config/edit/by/code',
                    rule: {
                        app_id: '请填写AppID',
                        partner: '请填写收款账号',
                        key: '请填写密钥KEY',
                        private_key: '请填写支付宝秘钥',
                        public_key: '请填写支付宝公钥',
                    },
                    dataFormatter: data => {
                        this.alipayReceiveAccount = {
                            app_id:data.app_id,
                            partner:data.partner,
                            key:data.key,
                            private_key:data.private_key,
                            public_key:data.public_key
                        }
                        var submitObj = {};
                        submitObj.config_item_code = 'ALIPAY_RECEIVE_ACCOUNT';
                        submitObj.config_item_value = JSON.stringify(this.alipayReceiveAccount);
                        return submitObj;
                    },
                    success:(data,res) => {
                        this.$refs.aliPayEdit.close();
                        this.$message({
                            text: '支付宝收款账户信息配置成功',
                            icon: 'success'
                        });
                    },
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>

</style>